<template>
  <CustomModal id="report-content-modal"
               class="basic-modal"
               :title="$t('common.report')"
               :close-title="$t('common.cancel')"
               :ok-title="$t('common.confirmation')"
               :ok-busy="busy"
               :okDisabled="isDisabled"
               @cancel="$emit('cancel')"
               @ok="reportContent()">
    <div>
      <Radio id="option-content-has-error"
             :model-value="reportIssue"
             :check-value="1"
             @change="onRadioSelect">
        <span slot="label">
          {{ reportContentType.error }}
        </span>
      </Radio>

      <Radio id="option-content-is-inappropriate"
             :model-value="reportIssue"
             :check-value="2"
             @change="onRadioSelect">
        <span slot="label">
          {{ reportContentType.inappropriate }}
        </span>
      </Radio>

      <Radio id="option-content-input-text"
             :model-value="reportIssue"
             :check-value="3"
             @change="onRadioSelect">
        <span slot="label">
          {{ reportContentType.inputText }}
        </span>
      </Radio>

      <textarea v-model="reportContentMessage"
        v-if="isReportInputText"
        maxlength="500"
        class="report-input-text"
        rows="10" 
        cols="50"></textarea>

    </div>
  </CustomModal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { isNil } from 'lodash';

  export default {
    name: 'report-content-modal',

    props: {
      videoLecture: {
        type: Object,
        default: null,
      },
    },

    data() {
      return {
        reportIssue: 1,
        busy: false,
        userAgent: navigator.userAgent.toLowerCase(),
        reportContentType: {
          error: this.$t('report_content.error'),
          inappropriate: this.$t('report_content.inappropriate'),
          inputText: this.$t('report_content.input_text'),
        },
        reportContentMessage: '',
      };
    },

    computed: {
      ...mapGetters([
        'currentUserId',
        'currentUser',
      ]),

      isReportInputText() {
        if (this.reportIssue === 3) {
          return true;
        }

        return false;
      },

      reportIssueText() {
        if (this.reportIssue === 1) {
          return this.reportContentType.error;
        }

        if (this.reportIssue === 2) {
          return this.reportContentType.inappropriate;
        }

        return this.reportContentType.inputText;
      },

      isDisabled() {
        return this.reportContentMessage.length === 0 && this.reportIssue === 3;
      },
    },

    methods: {
      ...mapActions([
        'sendSlackContentReports',
      ]),

      onRadioSelect(value) {
        this.reportIssue = value;
      },

      reportContent() {
        if (!this.busy && !isNil(this.videoLecture)) {
          this.busy = true;
          const params = {
            lecture_type: 'video' || null,
            platform: this.userAgent || null,
            id: this.videoLecture.id || null,
            title: this.videoLecture.title || null,
            subject_id: this.videoLecture.subject_id || null,
            domain_id: this.videoLecture.domain_id || null,
            grade_id: this.videoLecture.grade_id || null,
            video_course_id: this.videoLecture.video_course_id || null,
            video_id: this.videoLecture.video.id || null,
            course: this.videoLecture.course || null,
            external_video_id: this.videoLecture.video.external_video_id || null,
            owner: this.videoLecture.owner || null,
            reason: this.reportIssueText,
            reported_from: this.$route.fullPath,
            reported_at: (new Date()).toString(),
            reported_message: this.reportContentMessage || null,
          };

          const userInfo = `${this.currentUser.name}(${this.currentUser.role} ${this.currentUser.user_id})`;

          this.sendSlackContentReports({ params, userInfo })
            .then(() => {
              this.busy = false;
              this.$emit('ok');
            });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>

  .report-input-text {
    border: solid 0.8px #cecece;
    border-radius: 2px;
  }

</style>




// WEBPACK FOOTER //
// ReportContentModal.vue?03c9ddf8